import { render } from "./Lock.vue?vue&type=template&id=6a9e3406&ts=true"
import script from "./Lock.vue?vue&type=script&lang=ts"
export * from "./Lock.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__